import {makeReactContext} from 'lib/makeReactContext';

interface DocumentEditorContextData {
  documentParentId?: string;
}

function getDocumentEditorContextFallback(): DocumentEditorContextData {
  return {
    documentParentId: undefined,
  };
}

const DocumentEditorContext = makeReactContext<DocumentEditorContextData>(
  getDocumentEditorContextFallback,
  'DocumentEditorContext'
);

export default DocumentEditorContext;
